import { mapGetters, mapActions, mapState } from 'vuex'
import debounce from 'lodash.debounce'
import SettingsTable from './components/settings-table/settings-table.vue'
import EditSettingsModal from '@/components/modals/edit-settings-modal/edit-settings-modal.vue'
import EditSingleSettingModal from '@/components/modals/edit-single-setting-modal/edit-single-setting-modal.vue'
import IcEdit from '@/assets/svg/ic-edit.svg?inline'

export default {
  name: 'GlobalSettings',
  components: {
    SettingsTable,
    EditSettingsModal,
    EditSingleSettingModal,
    IcEdit
  },
  computed: {
    ...mapState({
      selectedCity: state => state.manufactures.selectedCity,
      selectedAreas: state => state.manufactures.selectedAreas
    }),
    ...mapGetters({
      manufactures: 'globalSettings/getManufactures',
      schema: 'globalSettings/getSchema',
      selectedManufactoryIds: 'globalSettings/getSelectedManufactoryIds',
      isLoading: 'globalSettings/isLoading'
    })
  },
  watch: {
    selectedCity() {
      this.loadDataDebounce()
    },
    selectedAreas: {
      handler() {
        this.loadDataDebounce()
      },
      deep: true
    }
  },
  mounted() {
    this.$bus.$on('refresh-managers-info', this.loadDataDebounce)
    this.loadData()
  },
  beforeDestroy() {
    this.$bus.$off('refresh-managers-info', this.loadDataDebounce)
    this.clearSelection()
  },
  methods: {
    ...mapActions({
      fetchSettings: 'globalSettings/fetchSettings',
      clearSelection: 'globalSettings/clearSelection',
      saveSettings: 'globalSettings/saveSettings'
    }),

    async loadData() {
      await this.fetchSettings()
    },

    loadDataDebounce: debounce(function() {
      this.loadData()
    }, 500),

    openMassEditModal() {
      this.$refs.editSettingsModal.show()
    },

    onEditRow() {
      this.$refs.editSettingsModal.show()
    },

    onEditCell({ manufactureId, settingKey }) {
      this.$refs.editSingleSettingModal.show(manufactureId, settingKey)
    },

    async onSettingsSave(payload) {
      try {
        await this.saveSettings(payload)
      } catch (error) {
        console.error('Failed to save settings:', error)
      }
    }
  }
}
